import Alert from '@grouper/modules/core/components/Alert'
import Avatar from '@grouper/modules/core/components/Avatar'
import Badge from '@grouper/modules/core/components/Badge'
import BadgeCollaborator from '@grouper/modules/core/components/BadgeCollaborator'
import Button from '@grouper/modules/core/components/Button'
import ButtonAdd from '@grouper/modules/core/components/ButtonAdd'
import ButtonFloating from '@grouper/modules/core/components/ButtonFloating'
import ButtonIcon from '@grouper/modules/core/components/ButtonIcon'
import ButtonText from '@grouper/modules/core/components/ButtonText'
import CallToAction from '@grouper/modules/core/components/CallToAction.vue'
import Checkbox from '@grouper/modules/core/components/Checkbox'
import Chips from '@grouper/modules/core/components/Chips'
import ColorInput from '@grouper/modules/core/components/ColorInput'
import Context from '@grouper/modules/core/components/Context'
import Copied from '@grouper/modules/core/components/Copied'
import DownloadLink from '@grouper/modules/core/components/DownloadLink'
import Dropdown from '@grouper/modules/core/components/Dropdown'
import DropdownItem from '@grouper/modules/core/components/DropdownItem'
import DropdownSection from '@grouper/modules/core/components/DropdownSection'
import Editable from '@grouper/modules/core/components/Editable'
import Error from '@grouper/modules/core/components/Error'
import Expandable from '@grouper/modules/core/components/Expandable.vue'
import FormElement from '@grouper/modules/core/components/FormElement'
import FormGroup from '@grouper/modules/core/components/FormGroup'
import FormInput from '@grouper/modules/core/components/FormInput'
import FormRow from '@grouper/modules/core/components/FormRow'
import FormSection from '@grouper/modules/core/components/FormSection'
import FormTextarea from '@grouper/modules/core/components/FormTextarea'
import HelpIcon from '@grouper/modules/core/components/HelpIcon'
import Icon from '@grouper/modules/core/components/Icon'
import ImageInput from '@grouper/modules/core/components/ImageInput'
import List from '@grouper/modules/core/components/List'
import Logo from '@grouper/modules/core/components/Logo'
import MarkdownIt from '@grouper/modules/core/components/MarkdownIt'
import Modal from '@grouper/modules/core/components/Modal'
import Picker from '@grouper/modules/core/components/Picker'
import Presentation from '@grouper/modules/core/components/Presentation'
import ProgressBar from '@grouper/modules/core/components/ProgressBar'
import Radio from '@grouper/modules/core/components/Radio'
import RadioButton from '@grouper/modules/core/components/RadioButton'
import RadioCard from '@grouper/modules/core/components/RadioCard'
import RadioGroup from '@grouper/modules/core/components/RadioGroup'
import ReadOnlyForm from '@grouper/modules/core/components/ReadOnlyForm'
import Scrollbars from '@grouper/modules/core/components/Scrollbars'
import SegmentControl from '@grouper/modules/core/components/SegmentControl'
import SelectSearch from '@grouper/modules/core/components/SelectSearch'
import SwitchButton from '@grouper/modules/core/components/SwitchButton'
import SwitchInput from '@grouper/modules/core/components/SwitchInput'
import Tab from '@grouper/modules/core/components/Tab'
import Tabs from '@grouper/modules/core/components/Tabs'
import Thumbnail from '@grouper/modules/core/components/Thumbnail'
import autoOverflowScroll from '@grouper/modules/core/directives/autoOverflowScroll'
import autoScroll from '@grouper/modules/core/directives/autoScroll'
import clickOutside from '@grouper/modules/core/directives/clickOutside'
import preventParentScroll from '@grouper/modules/core/directives/preventParentScroll'
import scroll from '@grouper/modules/core/directives/scroll'
import sortable from '@grouper/modules/core/directives/sortable'
import tooltip from '@grouper/modules/core/directives/tooltip'
import userFileUpload from '@grouper/modules/core/directives/userFileUpload'

function setupVue(app) {
  app.component('Context', Context)
  app.component('Modal', Modal)
  app.component('Editable', Editable)
  app.component('Dropdown', Dropdown)
  app.component('DropdownSection', DropdownSection)
  app.component('DropdownItem', DropdownItem)
  app.component('Checkbox', Checkbox)
  app.component('Radio', Radio)
  app.component('RadioGroup', RadioGroup)
  app.component('RadioCard', RadioCard)
  app.component('Scrollbars', Scrollbars)
  app.component('Alert', Alert)
  app.component('Error', Error)
  app.component('SwitchInput', SwitchInput)
  app.component('Copied', Copied)
  app.component('MarkdownIt', MarkdownIt)
  app.component('DownloadLink', DownloadLink)
  app.component('FormElement', FormElement)
  app.component('Picker', Picker)
  app.component('ProgressBar', ProgressBar)
  app.component('Tab', Tab)
  app.component('Tabs', Tabs)
  app.component('List', List)
  app.component('HelpIcon', HelpIcon)
  app.component('Badge', Badge)
  app.component('BadgeCollaborator', BadgeCollaborator)
  app.component('Expandable', Expandable)
  app.component('Button', Button)
  app.component('ButtonText', ButtonText)
  app.component('ButtonFloating', ButtonFloating)
  app.component('ButtonAdd', ButtonAdd)
  app.component('ButtonIcon', ButtonIcon)
  app.component('Chips', Chips)
  app.component('RadioButton', RadioButton)
  app.component('Thumbnail', Thumbnail)
  app.component('Avatar', Avatar)
  app.component('Presentation', Presentation)
  app.component('FormInput', FormInput)
  app.component('FormTextarea', FormTextarea)
  app.component('CallToAction', CallToAction)
  app.component('FormGroup', FormGroup)
  app.component('FormRow', FormRow)
  app.component('ColorInput', ColorInput)
  app.component('ImageInput', ImageInput)
  app.component('SelectSearch', SelectSearch)
  app.component('Logo', Logo)
  app.component('ReadOnlyForm', ReadOnlyForm)
  app.component('FormSection', FormSection)
  app.component('SegmentControl', SegmentControl)
  app.component('SwitchButton', SwitchButton)
  app.component('Icon', Icon)

  app.directive('scroll', scroll)
  app.directive('preventParentScroll', preventParentScroll)
  app.directive('tooltip', tooltip)
  app.directive('sortable', sortable)
  app.directive('autoOverflowScroll', autoOverflowScroll)
  app.directive('userFileUpload', userFileUpload)
  app.directive('autoScroll', autoScroll)
  app.directive('clickOutside', clickOutside)

  app.config.globalProperties.$super = function (options) {
    return new Proxy(options, {
      get: (opts, name) => {
        if (opts.methods && name in opts.methods) {
          return opts.methods[name].bind(this)
        }
      },
    })
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  setupVue(nuxtApp.vueApp)
})

export { setupVue }
